
import { eDispatchType, iNetbar } from '@/interface/result';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
@Component
export default class extends Vue {
  @Prop() model!: iNetbar;
  @Prop() selectedDispatchType!: eDispatchType;
  @Prop() title!: string;
  @Prop() loading!: boolean;
  publicDispath: eDispatchType = eDispatchType.PUBLIC_DISPACTH;
  rules = {
    // low_pool_id: [{ required: true, message: '请输入体验服调度池ID', trigger: 'blur' }],
    // high_pool_id: [{ required: true, message: '请输入高配服调度池ID', trigger: 'blur' }],
    // free_pool_id: [{ required: true, message: '请输入标配服调度池ID', trigger: 'blur' }],
    port_mapping_prefix: [{ required: true, trigger: 'blur' ,validator:this.checkPortMappingPrefix}]
  };
  checkPortMappingPrefix(rule: any, value: any, callback: any){
    const myRegex = /^[0-6]$/; 
    const errStr="映射端口只能填0-6的一位数字";
    if (this.selectedDispatchType == this.publicDispath) {
      try{
        if(!myRegex.test(this.model.port_mapping_prefix!))
        {
          return callback(errStr)
        }
        return callback();
      }catch{
        return callback(errStr)
      }
     
    }

    return callback();
  }
  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.$emit('submit', this.model);
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  @Emit()
  close() {}
}
